import { Icon } from '@cbhq/cds-web/icons';
import { ANALYTICS_KEY } from '../../constants.js';
import { Button } from '../../ui/Button.js';
import '../../ui/Div/index.js';
import { LinkButton } from '../../ui/Link/LinkButton.js';
import '../../ui/RichText/index.js';
import { Text } from '../../ui/Text.js';
import { labelOptions } from './RichtextOptions.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { Div } from '../../ui/Div/Div.js';
import { RichText } from '../../ui/RichText/RichText.js';
function Row({
  isColumnHead,
  headline,
  subhead,
  label,
  subLabel,
  foreground,
  foregroundSecondary,
  background,
  borderColor = 'primary',
  alignContent = 'center',
  justifyContent = 'center',
  borderedEnd,
  bordered,
  hasCheck,
  isPositiveCheck = true,
  ctaUrl,
  ctaLabel,
  ctaVariant
}) {
  return /*#__PURE__*/jsxs(Div, {
    flexDirection: "column",
    spacing: 2,
    minHeight: 88,
    background: background,
    justifyContent: justifyContent,
    alignItems: alignContent,
    css: {
      p: {
        textAlign: alignContent
      }
    },
    borderedStart: bordered,
    borderedEnd: bordered,
    borderedBottom: borderedEnd,
    borderColor: borderColor,
    children: [headline && /*#__PURE__*/jsx(Text, {
      variant: isColumnHead ? 'title3' : 'label1',
      color: foreground,
      css: {
        textAlign: alignContent
      },
      children: headline
    }), subhead && /*#__PURE__*/jsx(RichText, {
      content: subhead,
      color: foregroundSecondary,
      richTextOptions: labelOptions,
      defaultSpacingTop: 0.5
    }), label && /*#__PURE__*/jsx(Text, {
      variant: {
        sm: 'label2',
        lg: 'label1'
      },
      color: foreground,
      css: {
        textAlign: alignContent
      },
      children: label
    }), ctaLabel && (ctaUrl ? /*#__PURE__*/jsx(LinkButton, {
      variant: ctaVariant,
      href: ctaUrl,
      "data-qa": ANALYTICS_KEY.Row,
      children: ctaLabel
    }) : /*#__PURE__*/jsx(Button, {
      variant: ctaVariant,
      disabled: true,
      children: ctaLabel
    })), subLabel && /*#__PURE__*/jsx(RichText, {
      content: subLabel,
      color: foregroundSecondary,
      richTextOptions: labelOptions,
      defaultSpacingTop: 0.5
    }), hasCheck && /*#__PURE__*/jsx(Icon, {
      name: "circleCheckmark",
      color: isPositiveCheck ? 'positive' : 'foregroundMuted',
      size: "m"
    })]
  });
}
export { Row };
//# sourceMappingURL=Row.js.map
